// src/stores/simulation.js
import { defineStore } from "pinia";
import simulationService from "@/api/simulationService"; // adjust path if needed

export const useSimulationStore = defineStore("simulation", {
  state: () => ({
    alarms: [],
    totalAlarms: 0,
    currentPage: 1,
    pageSize: 10,
  }),

  actions: {
    /**
     * Trigger an alarm for the given project and alarm time.
     */
    async createAlarm(projectId, alarmDatetime) {
      try {
        const result = await simulationService.createAlarm(
          projectId,
          alarmDatetime
        );
        // result might be a string from the server
        console.log("Alarm triggered:", result);
        // Optionally re-fetch alarms if you want updated state
        // await this.fetchAlarms(projectId);
      } catch (error) {
        console.error("Error triggering alarm:", error);
        throw error;
      }
    },

    /**
     * Fetch paginated alarms for the given project.
     */
    async fetchAlarms(projectId, page = 1, size = 10) {
      try {
        const data = await simulationService.getAlarmsForProject(
          projectId,
          page,
          size
        );
        // Data has shape: { total, page, size, items: [...] }

        this.alarms = data.items;
        this.totalAlarms = data.total;
        this.currentPage = data.page;
        this.pageSize = data.size;
      } catch (error) {
        console.error("Error fetching alarms:", error);
        throw error;
      }
    },
  },
});
